import sizeOfMobilepayLogo from "size.js!=!odendo-image-size-loader?module!../../shop-checkout/payment-methods/mobilepay.png?width=100";
import mobilepayLogo100 from "odendo-image-resizer?module!../../shop-checkout/payment-methods/mobilepay.png?width=100";
import mobilepayLogo200 from "odendo-image-resizer?module!../../shop-checkout/payment-methods/mobilepay.png?width=200";
import mobilepayLogo300 from "odendo-image-resizer?module!../../shop-checkout/payment-methods/mobilepay.png?width=300";
import { createPaymentImageData } from "./base";
// const actualSizeOfMobilePayLogo = {
//     width: 100,
//     height: (100 / sizeOfMobilepayLogo.width) * sizeOfMobilepayLogo.height,
// };

export const imageData = createPaymentImageData(
    sizeOfMobilepayLogo,
    {
        url: mobilepayLogo100,
        width: 100,
    },
    {
        url: mobilepayLogo200,
        width: 200,
    },
    {
        url: mobilepayLogo300,
        width: 300,
    }
);
